import React from 'react';
import { Box, Typography } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LayersIcon from '@mui/icons-material/Layers';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useThemeContext } from '../../context/ThemeContext';

export const FeaturesGrid = () => {
    const { mode } = useThemeContext();
    const isLight = mode === 'light';

    const features = [
        {
            icon: <AccountTreeIcon fontSize="large" />,
            title: "Visual Algorithms",
            description: "Don't just read code. Watch pointers, arrays, and variables mutate in real-time, line-by-line.",
            color: "#ef4444"
        },
        {
            icon: <LayersIcon fontSize="large" />,
            title: "Architecture Deep Dives",
            description: "Expert case studies on Micro-Frontends, WebSockets, and scaling logic to millions of users.",
            color: "#3b82f6"
        },
        {
            icon: <TipsAndUpdatesIcon fontSize="large" />,
            title: "Multi-Language",
            description: "View DSA solutions in Python, Java, and JavaScript instantly without refreshing the page.",
            color: "#10b981"
        },
        {
            icon: <LocalOfferIcon fontSize="large" />,
            title: "Highly Affordable",
            description: "Master complex systems and ace your interviews at a fraction of the cost of traditional bootcamps.",
            color: "#f59e0b"
        }
    ];

    return (
        <Box sx={{ mb: 12 }}>
            <Typography variant="h3" fontWeight="800" textAlign="center" sx={{ mb: 6, color: isLight ? '#0f172a' : '#f8fafc' }}>
                Why choose FlowState?
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' }, gap: { xs: 4, xl: 6 } }}>
                {features.map((f, idx) => (
                    <Box key={idx} sx={{ p: { xs: 4, xl: 5 }, borderRadius: 4, bgcolor: isLight ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.02)', textAlign: 'center' }}>
                        <Box sx={{ 
                            width: 64, height: 64, borderRadius: '50%', 
                            bgcolor: `${f.color}20`, color: f.color, 
                            display: 'flex', alignItems: 'center', justifyContent: 'center', 
                            mx: 'auto', mb: 3 
                        }}>
                            {f.icon}
                        </Box>
                        <Typography variant="h6" fontWeight="700" mb={1} sx={{ color: isLight ? '#1e293b' : '#f8fafc' }}>
                            {f.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: isLight ? '#64748b' : '#94a3b8' }}>
                            {f.description}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
